import { EmbeddedContent } from "./EmbeddedContent/EmbeddedContent";
import { Office } from "./Office";
import { ResizableImage } from "./ResizableImage";

enum WebsiteProfileDisplayType {
    Agent,
    PersonalAssistant,
    PropertyManager,
    CommercialAgent,
    Principal,
    Office,
    Support
}

interface Profile {
    Id: string;

    FirstName: string;
    LastName: string;
    FullName: string;

    Position: string;
    
    DisplayPriority: number;
    DisplayType: WebsiteProfileDisplayType;

    OfficePhone: string;
    MobilePhone: string;
    Email: string;
    Website: string;

    FacebookUrl: string;
    FacebookHandle: string;
    LinkedInUrl: string;
    LinkedInHandle: string;
    TwitterUrl: string;
    TwitterHandle: string;
    RateMyAgentUrl: string;
    RateMyAgentHandle: string;
    InstagramUrl: string;
    InstagramHandle: string;

    AboutAgent: string;

    WebsiteVideoLink: string;
    EmbeddedWebsiteVideo: EmbeddedContent;

    Photo: ResizableImage;
    CoverPhoto: ResizableImage;

    Office: Office;

    Slug: string;
}

export { Profile, WebsiteProfileDisplayType }
